import * as React from "react";
import { useState } from "react";
import { useAppSelector } from "../../store/hooks";
import '../admin/styles/adminDashboard.css';
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import UploadPage from '../upload/index';
import SamlSetupPage from "../saml";

interface Tile {
    key: string;
    title: string;
    description: string;
    icon: JSX.Element;
    component: JSX.Element;
}

const ManagementDashboard: React.FC = () => {
    const { restrictions = [], userType } = useAppSelector((s) => s.auth);
    const [selectedSection, setSelectedSection] = useState<string | null>(null);

    const tiles: Tile[] = [
        {
            key: "upload",
            title: "Upload Rosters",
            description: "Upload and manage employee roster data",
            icon: <FolderSharedIcon fontSize="large" />,
            component: <UploadPage />,
        },
                {
            key: "saml",
            title: "SAML Configuration",
            description: "Configure SAML authentication settings",
            icon: <FolderSharedIcon fontSize="large" />,
            component: <SamlSetupPage />,
        },
    ];

    const visibleTiles = tiles.filter((tile) => !restrictions.includes(tile.key));
    const activeTile = tiles.find((tile) => tile.key === selectedSection);

    return (
        <div className="admin-dashboard-wrapper">
            <header className="admin-header-bar">
                <div className="admin-header-logo">
                    <div>
                        <h1>Management Portal</h1>
                        <p>Manage roster uploads, and saml settings</p>
                    </div>
                </div>
            </header>

            <div className="admin-dashboard-container">
                {!selectedSection ? (
                    <div className="admin-tile-grid">
                        {visibleTiles.map((tile) => (
                            <div
                                key={tile.key}
                                className="admin-tile"
                                onClick={() => setSelectedSection(tile.key)}
                            >
                                <div className="tile-icon">{tile.icon}</div>
                                <h3 className="tile-title">{tile.title}</h3>
                                <p className="tile-description">{tile.description}</p>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="admin-section-container">
                        <button className="back-button" onClick={() => setSelectedSection(null)}>
                            ← Back to dashboard
                        </button>
                        {activeTile?.component}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ManagementDashboard;
